import { CSSObject } from '@chakra-ui/react';
import bgHead from '@/assets/sterlingparker/images/backgrounds/bgHead.png';
import carbonFiber from '@/assets/sterlingparker/images/backgrounds/carbonFiber.png';
import bgMaintenanceMobile from '@/assets/sterlingparker/images/backgrounds/bgMaintenanceMobile.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: [null, null, 'center'],
  minH: '100dvh',
  background: `url(${bgMaintenanceMobile}), url(${carbonFiber})`,
  backgroundPosition: 'top',
  backgroundRepeat: 'no-repeat, repeat',
  backgroundSize: 'cover, 98px 98px',

  '@media (min-width: 371px)': {
    background: `url(${bgHead}), url(${carbonFiber})`,
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat, repeat',
    backgroundSize: '1700px 566px, 98px 98px',
  },
};

export const CenterWrapper: CSSObject = {
  bg: 'transparent',
  borderRadius: [null, null, 'xl'],
  color: 'white',
  flex: ['1', null, '0'],
  gap: '0',
  justifyContent: 'center',
  mt: ['0', null, '12'],
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  maxW: 'container.md',
  px: ['4', null, '24'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
};

export const ContentHeadingText: CSSObject = {
  fontFamily: 'CalistoMT',
  bgGradient: 'linear(to-b, #ffce70, #cc952b)',
  backgroundClip: 'text',
  fontSize: ['5xl', null, '7xl'],
  lineHeight: ['0.96', null, 'tall'],
  mt: ['1', null, '0'],
  mb: ['20px', null, '0'],
  pb: ['1', null, '0'],
};

export const ContentBodyText: CSSObject = {
  fontSize: 'md',
  lineHeight: 'tall',
  fontWeight: 'bold',
  textAlign: 'center',
  filter: 'drop-shadow(0px 5px 5px rgba(0,0,0,.5))',

  b: {
    display: 'block',
    fontSize: 'md',
    lineHeight: 'base',
    mb: '0',
  },

  '.chakra-link': {
    fontSize: ['2xs', 'xs'],
    fontWeight: 'bold',
  },
};

export const ContactText: CSSObject = {
  fontWeight: 'bold',
  '&&': {
    fontSize: ['sm', null, 'md'],
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  fontSize: ['sm', null, 'lg'],
  mt: '3',
  fontWeight: 'normal',
};

export const TextHeadingColor: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, gamma.500)',
  bgClip: 'text',
  textShadow: 'none',
  display: 'flex',
};

export const RegistrationContent: CSSObject = {
  fontSize: ['xs', null],
  fontWeight: 'normal',
  lineHeight: 'shorter',
  mt: '5',

  '.chakra-link': {
    fontSize: ['xs', null],
    fontWeight: 'bold',
  },
};
